export default [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/Public/Pages/Login')
    },
    {
        path: '/register',
        component: () => import(/* webpackChunkName: "Register" */ '@/views/Public/Pages/Register')
    },
    {
        path: '/register/:token',
        component: () => import(/* webpackChunkName: "Register" */ '@/views/Public/Pages/Register')
    },
    {
        path: '/forgotten-password',
		component: () => import(/* webpackChunkName: "ForgottenPassword" */ '@/views/Public/Pages/ForgottenPassword')
    },
	{
        path: '/reset-password/:token',
		component: () => import(/* webpackChunkName: "ResetPassword" */ '@/views/Public/Pages/ResetPassword')
    },
	{
        path: '/confirm-email/:token',
		component: () => import(/* webpackChunkName: "ConfirmEmail" */ '@/views/Public/Pages/ConfirmEmail')
    },
	{
        path: '/verify/:token',
		component: () => import(/* webpackChunkName: "VerifyAccount" */ '@/views/Public/Pages/VerifyAccount')
    },
	{
        path: '/invitation/:token',
		component: () => import(/* webpackChunkName: "Invitation" */ '@/views/Public/Pages/Invitation')
    },
	{
        path: '/transfer-ownership/:token',
		component: () => import(/* webpackChunkName: "Invitation" */ '@/views/Public/Pages/TransferOwnership')
    }
]
